import type { OfficeTransferFlg } from '~/types/code/code';
import type { WorkInfoPanelItemBase } from '~/types/work/workInfoPanel';

/**
 * 完了作業情報
 */
export type EndWorkInfo = {
  /** チェック状態 */
  checked: boolean;
  /** 伝票読込時にエラーが発生したかどうか */
  isReadError: boolean;
  /** 自身が作業中の作業かどうか */
  inWork: boolean;
  /** 単位作業ID */
  workId: string;
  /** 枝番 */
  branchNo: string;
  /** 代行枝番 */
  delegateBranchNo: string;
  /** 伝票番号版数 */
  documentEdition: string;
  /** 伝票番号 */
  documentNo: string;
  /**
   * 作業状態区分
   *
   * 0: 未設定、1: 作業中、2: 完了、3: 未完了
   */
  statusKbn: '0' | '1' | '2' | '3';
  /** 状態欄のラベル */
  statusKbnLabel: string;
  /** 原着駅名 */
  originalArrivalStationName: string;
  /** 列車番号 */
  trainNo: string;
  /** 持出駅名 */
  outStationName: string;
  /** 持込駅名 */
  inStationName: string;
  /** 代行利用者名 */
  delegateUserName: string;
  /** 代行利用者所属JR駅コード */
  delegateStationCd: string;
  /** 代行利用者所属社線駅サブコード */
  delegateStationSubCd: string;
  /** 代行利用者コード */
  delegateUserCompanyCd: string;
  /** 代行集配人コード */
  delegateDeliveryCompanyCd: string;
  /** 伝票に紐づいているオリジナルの代行利用者 */
  originalDelegateUser: {
  /** 代行利用者名 */
    delegateUserName: string;
    /** 代行利用者所属JR駅コード */
    delegateStationCd: string;
    /** 代行利用者所属社線駅サブコード */
    delegateStationSubCd: string;
    /** 代行利用者コード */
    delegateUserCompanyCd: string;
    /** 代行集配人コード */
    delegateDeliveryCompanyCd: string;
  };
  /** お客様名 */
  customerName: string;
  /** コンテナ番号 */
  containerNo: string;
  /** 指定日時 */
  assignDate: string;
  /** 封印環番号 */
  sealRingNo?: string;
  /** 留置フラグ */
  putFlg: '0' | '1';
  /** 不良フラグ */
  badFlg: '0' | '1';
  /** 荷造包装確認 */
  packingFlg?: '0' | '1';
  /** コンテナ表示挿入確認 */
  containerInsertFlg?: '0' | '1';
  /** コンテナハッチ開扉確認 */
  containerHatchOpenFlg?: '0' | '1';
  /** 外装危険品除去確認 */
  dangerousGoodsRemoveFlg?: '0' | '1';
  /** 宣誓 */
  oathFlg?: '0' | '1';
  /** EDI管理番号 */
  ediNo: string;
  /** 警告確認フラグ */
  emergencyFlg: '0' | '1';
  /** 営業所移送発着フラグ */
  officeTransferFlg?: OfficeTransferFlg;
  /** 原票番号 */
  originalDocumentNo?: string;
} & WorkInfoPanelItemBase;

type State = {
  /** 読み込んだ完了作業情報 */
  endWorkInfoList: EndWorkInfo[];
};

/**
 * コンテナ持込画面の情報を管理するストア
 */
export const useContainerInStore = defineStore('container-in', {
  state: (): State => ({
    endWorkInfoList: [],
  }),
});
